import { Controller } from "@hotwired/stimulus"

// A tile that is a still until the pointer rests on it, then plays its video
// muted over the still (/design's ribbon). The src is only given on the first
// hover, so a row of fourteen tiles costs fourteen thumbnails and no mp4.
export default class extends Controller {
  static targets = ["video"]

  play() {
    const video = this.videoTarget
    if (!video.src) video.src = video.dataset.src
    video.play().then(() => video.classList.remove("opacity-0")).catch(() => {})
  }

  pause() {
    this.videoTarget.pause()
    this.videoTarget.classList.add("opacity-0")
  }
}
